var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-project-list-item-open-state",class:_vm.statusIndicatorClass},[_c('span',{staticClass:"status-label"},[_vm._v(" "+_vm._s(_vm.t(`project-forum_USERTYPE.status.${_vm.status}`))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }